import { memoize } from 'lodash';
import { sortByOrder } from 'utils/array';
import { PLATFORM_TYPES } from '@sitegen/common/constants/platforms';

const memoizePlatforms = (order: PLATFORM_TYPES[], platforms: PLATFORM_TYPES[]): () => PLATFORM_TYPES[] =>
    memoize(() => sortByOrder(platforms, order));

export default memoizePlatforms;
